import React, { useEffect, useState, useMemo } from 'react';
import { Button, Card, message, Typography, Image, Tooltip, Skeleton } from 'antd';
import { HomeOutlined, EditOutlined, FilePdfOutlined, MailOutlined } from '@ant-design/icons';

import AnalystProcessFsForm from './AnalystProcessFsForm';
import AnalystProcessFsFormPreview from './AnalystProcessFsFormPreview';
import mohLogo from '../../../assets/images/Mohawk_Industries_logo.png';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import {saveAnalystFsInspectionReport, getAnalystFsInspectionReport,getAnalystFsInspectionRequest,generateAnalystPdfInspectionReport} from '../../../services/AnalystFsReportApis';
const AnalystProcessFsFormContainer = () => {
    const [currentView, setCurrentView] = useState('form'); // 'form', 'preview'
    const [reportData, setReportData] = useState({});
    const [formData, setFormData] = useState({});
    const { Title, Text } = Typography;
    const [loading, setLoading] = useState(false);
    const [pdfLoading, setPdfLoading] = useState(false);
    const dispatch = useDispatch();
    const [skipNextFetch, setSkipNextFetch] = useState(false);  
    const navigate = useNavigate();
    const userDetails = useSelector((state) => state.User.userDetails);
    const userRole = userDetails?.user_role;

    const queryParams = useMemo(() => new URLSearchParams(window.location.search), []);
    const reportId = queryParams.get('report_id');
    const requestId = queryParams.get('req_id');


    const handleFormSubmit = (formData) => {
        
        setLoading(true);
        const updatedFormData = {
            ...formData,
            ...(reportId && { reportId: reportId }),
            ...(requestId && { reqId: requestId }),
            report_type: 'out_of_warranty', // Mark as out of warranty report
        };
        console.warn("handleFormSubmit",updatedFormData);
        //return true;
        dispatch(saveAnalystFsInspectionReport(updatedFormData))
            .then((response) => {
                setLoading(false);
                setCurrentView('preview');
                if (response.reportId) {
                    setReportData(response.reportData);
                    console.log("Report data set successfully", response.reportData);
                    // Set the flag to skip the next fetch
                    setSkipNextFetch(true);
                    navigate(`/analyst-fs-process-form/?report_id=${response.reportId}`)
                }
                message.success('Report submitted successfully!');
                console.log("Report saved successfully", response);
            })
            .catch((err) => {
                setLoading(false);
                console.error("Failed to save report", err)
            });

    };

    const handleGeneratePdf = (id) => {
        const finalId = id || reportId;
        if (!finalId) {
            message.error("Report ID is missing. Please ensure the report ID is available.");
            return;
        }

        setPdfLoading(true);
        dispatch(generateAnalystPdfInspectionReport(finalId))
            .then((res) => {
                setPdfLoading(false);
                window.open(res.pdf_url);
                // Refresh data to get the new analyst_report_pdf URL
                fetchData(finalId);
            })
            .catch((error) => {
                setPdfLoading(false);
                console.error("Failed to generate PDF report", error);
                message.error("Failed to generate PDF report. Please try again.");
            });
    };

    const fetchData = async (id = null) => {
        try {
            setLoading(true);
            let data = null;
            if (id) {
                console.log("Inside fetchData with id:", id); // Add logging
                data = await dispatch(getAnalystFsInspectionReport(id));
                console.log("Received data:", data); // Add logging
            } else if (requestId && !id) {
                console.log("Inside fetchData with requestId:", requestId); // Add logging
                data = await dispatch(getAnalystFsInspectionRequest(requestId));
                console.log("Received data from request:", data); // Add logging
            }
    
            if (data && Object.keys(data).length > 0) {
                console.log("Received data:", data); // Add logging
                setReportData(data);
                setFormData(data);
                // Only switch to preview if we have valid data and an ID
                if (id) setCurrentView('preview');
            } else {
                message.warning("Retrieved data is empty or incomplete");
                // Stay in form view if data is missing
                setCurrentView('form');
            }
    
            setLoading(false);
        } catch (err) {
            console.error("Failed to fetch report or request", err);
            message.error(`Failed to load data: ${err.message || "Unknown error"}`);
            setLoading(false);
        }
    };


    useEffect(() => {

        if (skipNextFetch) {
            setSkipNextFetch(false);
            return;
        }
        const newQueryParams = new URLSearchParams(window.location.search);
        const newReportId = newQueryParams.get('report_id');
        const newRequestId = newQueryParams.get('req_id');
        
        if (newReportId) {
            fetchData(newReportId);
        } else if (newRequestId && !newReportId) {
            fetchData();
        }

    }, [window.location.search]);  // Just use this single useEffect





    const ReportHeader = () => (
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>

            <Image
                src={mohLogo}
                alt="Mohawk Logo"
                preview={false}
                className='mohawak-logo'
                style={{ maxHeight: '100px', marginBottom: '16px' }}
            />

            <Title level={2}>Site Visit Report - Out of Warranty Product  </Title>
            {loading ? (
                <Skeleton.Input active size="default" style={{ width: '40%', marginBottom: '8px' }} />
            ) : (
                <Text>Address: 160 S. Industrial Blvd. Calhoun, GA 30701</Text>
            )}
        </div>
    );

    const navigateToHome = () => {
        navigate('/');
    };

    return (
        <div className='main-content-section' style={styles.container}>
            <div className='container py-0  my-5'>
                <div className='row'>
                    <Card className='tablet-padding-0' style={styles.card}>
                        <Button
                            icon={<HomeOutlined />}
                            onClick={navigateToHome}
                            className='home-mohawak-btn'
                            style={{ ...styles.button, marginBottom: '16px' }}
                        >
                            Home
                        </Button>
                        <ReportHeader />
                        {currentView === 'form' && (
                            <AnalystProcessFsForm
                                onFinish={handleFormSubmit}
                                loading={loading}
                                initialData={reportData}
                                onValuesChange={(_, values) => setFormData(values)}
                            />
                        )}

                        {currentView === 'preview' && (
                            <>
                                <AnalystProcessFsFormPreview formData={reportData} loading={loading} />
                                <div className="circle-button-div">
                                    {(userRole === 'um_fs_inspector' || userRole === 'um_fs_manager') && (
                                        <Tooltip title="Edit Report" placement="top">
                                            <Button
                                                type="primary"
                                                shape="circle"
                                                icon={<EditOutlined className="svg-icon" />}
                                                onClick={() => setCurrentView('form')}
                                                className="circle-custom-button"
                                                style={{ marginRight: '4px' }}
                                            />
                                        </Tooltip>
                                    )}
                                    {(reportId || reportData.analystReportId || reportData.report_id) && (
                                        <Tooltip title="Generate PDF" placement="top">
                                            <Button
                                                type="primary"
                                                shape="circle"
                                                loading={pdfLoading}
                                                icon={<FilePdfOutlined className="svg-icon" />}
                                                onClick={() => handleGeneratePdf(reportId || reportData.analystReportId || reportData.report_id)}
                                                className="circle-custom-button"
                                                style={{ marginRight: '4px' }}
                                            />
                                        </Tooltip>
                                    )}
                                    {reportData.req_id && reportData.report_generated === "YES" && (reportData.analyst_report_pdf || reportData.report_pdf) && (
                                        <Tooltip title="Send Email" placement="top">
                                            <Button
                                                type="primary"
                                                shape="circle"
                                                icon={<MailOutlined className="svg-icon" />}
                                                onClick={() =>
                                                    navigate('/send-email/?req_id=' + reportData.req_id)
                                                }
                                                className="circle-custom-button"
                                            />
                                        </Tooltip>
                                    )}
                                </div>
                            </>
                        )}
                    </Card>
                </div>
            </div>
        </div>
    );
};

const styles = {
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f0f2f5',
    },
    card: {
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        borderRadius: '12px',
        backgroundColor: '#fff',
    },
    button: {
        marginTop: '15px',
        borderRadius: '6px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    },
};

export default AnalystProcessFsFormContainer;